import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { IBusinessCategory } from '../../_interfaces/IBusinessCategory';

@Injectable({
  providedIn: 'root',
})
export class BusinessCategoriesService {
  constructor(private readonly http: HttpClient) {}

  private baseUrl(path = ''): string {
    const suffix = path ? `/${path}` : '';
    return `${environment.api.protocol}://${environment.api.host}:${environment.api.port}/api/v1/admin/business-categories${suffix}`;
  }

  getAll() {
    return this.http.get<IBusinessCategory[]>(this.baseUrl());
  }

  create(payload: Partial<IBusinessCategory>) {
    return this.http.post<IBusinessCategory>(this.baseUrl(), payload);
  }

  update(id: number, payload: Partial<IBusinessCategory>) {
    return this.http.patch<IBusinessCategory>(this.baseUrl(`${id}`), payload);
  }

  disable(id: number) {
    return this.http.delete(this.baseUrl(`${id}`));
  }
}

